import { render, staticRenderFns } from "./CheckoutPayment.vue?vue&type=template&id=1fa3c59a"
import script from "./CheckoutPayment.vue?vue&type=script&lang=ts"
export * from "./CheckoutPayment.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutPayment.vue?vue&type=style&index=0&id=1fa3c59a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports